import { render, staticRenderFns } from "./Shopstore.vue?vue&type=template&id=887d2bd4&"
import script from "./Shopstore.vue?vue&type=script&lang=js&"
export * from "./Shopstore.vue?vue&type=script&lang=js&"
import style0 from "./Shopstore.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports